import { render, staticRenderFns } from "./remove.vue?vue&type=template&id=13a5d66c&scoped=true&"
var script = {}
import style0 from "./remove.vue?vue&type=style&index=0&id=13a5d66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5d66c",
  null
  
)

export default component.exports